/* tslint:disable:max-line-length */
import * as React from 'react';

import { CarouselCardModel } from 'models';

import { UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkLink } from 'uitk-react-link';

import { CarouselCardLink } from './carousel-card-link';

export const CarouselCardContent: React.FunctionComponent<CarouselCardModel> = (props: CarouselCardModel) => {
  const { secondaryLink, primaryHeading, secondaryHeading, description, imageAttribution, stidKey, price } = props;
  const flexDirection = !secondaryHeading && !description && !imageAttribution && !price && !secondaryLink ? 'row' : 'column';

  return (
    <UitkCardContent className="uitk-flex uitk-flex-align-items-center">
      <UitkCardTextSegment className={`uitk-flex uitk-flex-${flexDirection} white-space-normal`}>
        <>
          {primaryHeading && <h3 data-stid={`${stidKey}-primary-heading`}>{primaryHeading}</h3>}
          {secondaryHeading && (
            <p className="all-t-margin-half uitk-type-200 pwa-theme--grey-700" data-stid={`${stidKey}-secondary-heading`}>
              {secondaryHeading}
            </p>
          )}
          {description && (
            <p className="all-t-margin-half uitk-type-200 pwa-theme--grey-700" data-stid={`${stidKey}-description`}>
              {description}
            </p>
          )}
          {price && (
            <div className="all-t-margin-two all-b-margin-two" data-stid={`${stidKey}-price`}>
              <div aria-hidden="true">
                <div className="all-t-padding-half">
                  <div className="uitk-grid all-grid-align-middle all-grid-align-start">
                    <span className="uitk-cell uitk-type-600 uitk-type-bold all-cell-shrink">
                      <span data-stid="content-hotel-lead-price" aria-hidden="true">
                        {price.value}
                      </span>
                    </span>
                  </div>
                  <div className="pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{price.messageTxt}</div>
                </div>
              </div>
              <p className="is-visually-hidden">{price.accessibilityText}</p>
            </div>
          )}
          {secondaryLink && <CarouselCardLink linkComponent={UitkLink} linkModel={secondaryLink} />}
          {imageAttribution && (
            <div className={'all-t-margin-two uitk-cell uitk-type-200'} data-stid={`${stidKey}-image-attribution`}>
              {imageAttribution.label}
            </div>
          )}
        </>
      </UitkCardTextSegment>
    </UitkCardContent>
  );
};
